import React from 'react'
import ContactForm from '../../../components/forms/ContactForm'
import SupportContactForm from '../../../components/forms/SupportContactForm'
import RMAForm from '../../../components/forms/RMAForm'
import TrainingRequestForm from '../../../components/forms/TrainingRequestForm'
import RequestAccessForm from '../../../components/forms/RequestAccessForm'
import SpeakUpForm from '../../../components/forms/SpeakUpForm'

function FormPart(props) {
	switch (props.form) {
		case 'support_contact_form':
			return <SupportContactForm {...props} />
		case 'rma_form':
			return <RMAForm {...props} />
		case 'training_request_form':
			return <TrainingRequestForm {...props} />
		case 'request_access_form':
			return <RequestAccessForm {...props} />
		case 'speak_up_form':
			return <SpeakUpForm {...props} />
		case 'contact_form':
		default:
			return <ContactForm {...props} />
	}
}

export default (props) => <FormPart {...props} />
